import Icon from '../components/Icon.vue'

Icon.register({
  paw: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 224c79.4 0 192 122.8 192 200.3 0 34.9-26.8 55.8-71.7 55.8-48.4 0-80.8-25.1-120.3-25.1-39.2 0-71.4 25.1-120.3 25.1-44.9 0-71.7-20.8-71.7-55.8 0-77.5 112.6-200.3 192-200.3zM108.7 211.4c10.4 34.7-4.8 68.4-33.9 75.3-29.1 7-61.2-15.5-71.6-50.1-10.4-34.6 4.8-68.4 33.9-75.3s61.2 15.5 71.6 50.1zM193.4 190.6c-30.9 8.1-65.6-20.5-77.5-63.9-11.8-43.4 3.6-85.2 34.6-93.4 30.9-8.1 65.6 20.5 77.5 63.9 11.8 43.4-3.6 85.2-34.6 93.4zM474.8 161.3c29.1 7 44.3 40.7 33.9 75.3-10.4 34.6-42.4 57.1-71.6 50.1s-44.3-40.7-33.9-75.3c10.4-34.7 42.4-57.1 71.6-50.1zM318.6 190.6c-30.9-8.1-46.4-49.9-34.6-93.4 11.8-43.4 46.5-72 77.5-63.9 30.9 8.2 46.4 49.9 34.6 93.4-11.8 43.4-46.5 72-77.5 63.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/paw.js
// module id = 1618
// module chunks = 0